import React, { useEffect } from 'react';
import { PaymentDetailsSkeleton } from '../skelton-loader';
import { PaymentCustomerInfo } from '../payment-customer';
import { PaymentMediaCard } from '../payment-media';
import { PaymentDetailsCard } from './payment-details-card';
import { PaymentInvoiceCard } from '../payment-invoice';
import { isEmpty } from 'lodash';
import { usePaymentDetails } from '../hooks';
import { PaymentDetailsModalGroup } from '../payment-modal';
import { CommonButton, PullRefreshContainer } from '../../components';
import { ReactComponent as ArrowRight } from '@zonofi/svg-icons/arrow_right.svg';
import {
  FileUploadOutput,
  PaymentDetailsByiIdResponse,
  PaymentDetailsState,
} from '@zonofi/zono-money-store';
import { SVGS } from '../../assets';
import './payment-details-screen-content.scss';

interface PaymentDetailsScreenContentProps {
  setPaymentInfo?: (state: PaymentDetailsState) => void;
  setResponse?: (response: PaymentDetailsByiIdResponse) => void;
}
export const PaymentDetailsScreenContent: React.FC<
  PaymentDetailsScreenContentProps
> = ({ setPaymentInfo = () => {}, setResponse = () => {} }) => {
  const {
    paymentCustInfo,
    mappedPaymentDetails,
    isPermittedToAcceptReject,
    onAcceptPress,
    onRejectPress,
    acceptLoader,
    successState,
    setSuccessState,
    onWhatsAppPress,
    onThreeDotPress,
    showThreeDotModal,
    setShowThreeDotModal,
    selectedMedia,
    modalState,
    setModalState,
    isLoading,
    response,
    refresh,
  } = usePaymentDetails();

  useEffect(() => {
    if (!isEmpty(mappedPaymentDetails)) {
      setPaymentInfo(mappedPaymentDetails);
    }
  }, [mappedPaymentDetails]);

  useEffect(() => {
    if (!isEmpty(response)) {
      setResponse(response);
    }
  }, [response]);

  return (
    <>
      <PullRefreshContainer
        className="payment-details-container"
        onRefresh={refresh}
      >
        {isLoading ? (
          <PaymentDetailsSkeleton />
        ) : (
          <div className="payment-details-scrollable">
            {!isEmpty(paymentCustInfo) && (
              <PaymentCustomerInfo paymentCustInfo={paymentCustInfo} />
            )}

            {!isEmpty(mappedPaymentDetails.paymentMedia) && (
              <PaymentMediaCard
                mediaFile={mappedPaymentDetails?.paymentMedia}
                onThreeDotPress={onThreeDotPress}
              />
            )}

            {!isEmpty(mappedPaymentDetails.paymentDetails) && (
              <PaymentDetailsCard
                paymentDetails={mappedPaymentDetails?.paymentDetails}
              />
            )}

            {!isEmpty(mappedPaymentDetails.paymentInvoice) && (
              <PaymentInvoiceCard
                paymentInvoice={mappedPaymentDetails?.paymentInvoice}
              />
            )}
          </div>
        )}
      </PullRefreshContainer>
      {!isLoading && isPermittedToAcceptReject && (
        <div className="payment-details-buttons-view">
          <CommonButton
            text="Reject"
            buttonStyle="reject-button-view"
            onPress={onRejectPress}
            endIcon={SVGS.CloseWhite}
            spinnerColor="white"
            spinnerStyle="reject-button-view-spinner"
            loading={false}
            spinnerSize={20}
          />
          <CommonButton
            text="Accept"
            buttonStyle="accept-button-view"
            onPress={onAcceptPress}
            endIcon={<ArrowRight color="#ffffff" />}
            spinnerStyle="accept-button-view-spinner"
            spinnerColor="white"
            spinnerSize={20}
            loading={acceptLoader}
          />
        </div>
      )}
      <PaymentDetailsModalGroup
        successState={successState}
        threeDotState={showThreeDotModal}
        selectedMedia={selectedMedia as FileUploadOutput}
        modalState={modalState}
        onWhatsAppPress={onWhatsAppPress}
        onCloseMediaModal={() => setShowThreeDotModal(false)}
        onCloseSuccessModal={() => setSuccessState(false)}
        onViewImagePress={() =>
          setModalState({ showOption: false, showImage: true })
        }
      />
    </>
  );
};
